import { Icon } from '@types';

export const AssessedTakeIcon = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			width="512"
			height="512"
			viewBox="0 0 512 512"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			onClick={handleClick}
			className={customStyles}
		>
			<path
				d="M304.529 85.1449C284.127 50.1138 266.505 19.8563 262.229 5.36972C261.284 2.18102 258.79 0.0416565 255.961 0C253.347 0.0952149 250.587 2.02728 249.588 5.18425C245.236 18.8833 228.506 47.5995 209.132 80.8741C164.763 157.032 104 261.34 104 329.204C104 429.304 172.131 510.741 255.882 510.741C339.633 510.741 407.764 429.304 407.764 329.204C407.764 262.437 348.094 159.967 304.529 85.1449Z"
				fill="#1C3A70"
			/>
			<path
				d="M453 391C453 330.271 403.729 281 343 281C282.271 281 233 330.271 233 391C233 451.729 282.271 501 343 501C403.729 501 453 451.729 453 391Z"
				fill="white"
				stroke="#A2D2E8"
				stroke-width="20"
				stroke-miterlimit="10"
			/>
			<path
				d="M399.993 343.174L319.087 439.49L284.413 400.964"
				stroke="#1D3B70"
				stroke-width="20"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};
